import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BatchRoutingModule } from './batch-routing.module';
import { BatchComponent } from './batch.component';

@NgModule({
  declarations: [BatchComponent],
  imports: [CommonModule, BatchRoutingModule],
})
export class BatchModule {}
